<template>
	<div style="font-family: -apple-system-font ,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
		<div class="carousel">
			<img src="../../assets/images/developerCommunity/dev_banner.jpg" alt="">
		</div>
		<div class="case_main">
			<div class="case_top">
				<div class="case_title">工业互联网加速落地深耕</div>
				<div class="case_time">
					<span><img src="../../assets/images/developerCommunity/dev_time.png" alt="">2020/06/12</span>
					<span><img src="../../assets/images/developerCommunity/dev_people.png" alt="">Eiiplat 平台</span>
				</div>
				<hr>
			</div>
			<div class="case_detail">
				<div class="model">
					<div class="section">
						工业物联网的价值体现是主要包括：提升价值、优化资源、升级服务和激发创新。
					</div>
				</div>
				<div class="model">
					<div class="model_title">提升价值：</div>
					<div class="section">
						工业物联网使丰富的生产、机器、人、流程、产品数据进行互联，数据达到前所未有的深度和广度的集成，建立物理世界与信息世界的映射关系，使数据的价值得以挖掘利用，提升数据的价值。
					</div>
				</div>
				<div class="model">
					<div class="model_title">优化资源</div>
					<div class="section">
						工业物联网通过网络通信技术将工业资源全面互联，通过数据处理和智能分析，对工业领域所有过程得出科学合理的决策，反馈至物理世界并对资源进行调度重组，使工业资源的利用达到前所未有的高效。
					</div>
				</div>
				<div class="model">
					<div class="model_title">升级服务</div>
					<div class="section">
						工业物联网的应用使制造企业改变原有的产品短期交易的状态，向以数据为核心的制造服务转变，打破传统的产业界限，升级服务重构企业与用户的商业关系，升级服务也帮助企业形成以数据价值为特征的新资产。
					</div>
				</div>
				<div class="model">
					<div class="model_title">激发创新</div>
					<div class="section">
						工业互联网在工业领域架起一座物理世界和信息世界连通的桥梁，并且提供接口供应用访问物理世界和信息世界，为资源高效灵活利用的开发提供无线可能，营造创新环境。
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'DeveloperGyhlwDetail',
		data() {
			return {
				detailId: this.$route.params.id,
			}
		},
		mounted() {
			window.scrollTo(0, 0)
			this.init()
		},
		methods: {
			init() {
				console.log(this.detailId)
			}
		}
	}
</script>

<style lang="scss">
.carousel {
		img {
			width: 100%;
		}
	}

	.case_main {
		padding: 0 2.4rem;
		margin-bottom: 0.3rem;
		.case_top{
			margin-top: 0.6rem;
			.case_title{
				font-size: 0.4rem;
			}
			.case_time {
				display: flex;
				span {
					font-size: 0.18rem;
					color: #999;
					margin-right: 0.35rem;
					display: flex;
					align-items: center;
				}

				img {
					width: 0.2rem;
					height: 0.2rem;
					margin-right: 0.1rem;
				}
			}
			hr{
				margin: 0.4rem 0;
				color: #cccccc;
			}
		}
		.case_detail{
			margin: 0 2.2rem;
			margin-bottom: 0.6rem;
			color: #000000;
			img {
				width: 100%;
			}
			.model{
				margin-top: 0.2rem;
				.model_title{
					font-size: 0.22rem;
					font-weight: 600;
				}
				.section{
					padding-left: 0.12rem;
					text-indent: 2em;
					line-height: 0.36rem;
					font-size: 0.18rem;
					margin-top: 0.12rem;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/DeveloperGyhlwDetail.vue